import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useApp } from "../lib/app";
import { LEGAL } from "../lib/legal";
import { Plain } from "../components/Shell";

export function Md({ text }) {
  return (
    <div className="space-y-2 text-[16px] leading-relaxed">
      {text.split("\n").map((l, i) => l.startsWith("## ") ? <h2 key={i} className="font-display text-xl font-bold pt-3">{l.slice(3)}</h2>
        : l.trim() === "" ? <div key={i} className="h-1" /> : <p key={i} className={l.startsWith("•") ? "pl-4 -indent-3" : ""}>{l}</p>)}
    </div>
  );
}

export default function Legal() {
  const { page } = useParams();
  const nav = useNavigate();
  const p = LEGAL[page];
  if (!p) return <Navigate to="/" replace />;
  return (
    <Plain>
      <button data-testid="legal-back" onClick={() => (window.history.length > 1 ? nav(-1) : nav("/"))} className="pt-5 text-[#6A5AE0] font-bold">← Back</button>
      <p className="ul-label mt-4">UnloadIt · Version 1.0 · Effective 24 October 2026</p>
      <h1 className="font-display text-3xl font-extrabold mb-4" data-testid="legal-title">{p.title}</h1>
      <div className="ul-card p-5"><Md text={p.body} /></div>
      {page === "ai" && <button data-testid="legal-ai-gotit" className="ul-btn ul-primary w-full mt-4" onClick={() => nav(-1)}>Got it</button>}
    </Plain>
  );
}

export function DeleteAccount() {
  const { me, logout } = useApp();
  const nav = useNavigate();
  const [text, setText] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (done) { const t = setTimeout(() => logout(), 3500); return () => clearTimeout(t); } }, [done, logout]);
  const go = async () => {
    setBusy(true);
    try { await api.post("/account/delete", { confirm: text }); setDone(true); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (done) return <div className="pt-24 text-center" data-testid="delete-done"><div className="text-5xl">🌸</div><p className="font-display text-2xl font-bold mt-3">Your account has been deleted. Thank you for using UnloadIt.</p></div>;
  return (
    <div className="pt-6 space-y-4">
      <h1 className="font-display text-3xl font-extrabold">Delete your account</h1>
      <div className="ul-card p-5 space-y-2">
        <p>This will permanently delete:</p>
        <p className="pl-4">• your account and login,</p>
        <p className="pl-4">• your tasks, lists, meal plans, check-ins and helper records,</p>
        <p className="pl-4">• if you are the home owner: the whole home, including the names of family members you added. Members with their own accounts will keep their accounts but will be removed from this home.</p>
        <p>This cannot be undone. We delete your data within 30 days.</p>
        <p className="font-bold">Type DELETE to confirm.</p>
        <input data-testid="delete-confirm-input" className="ul-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="DELETE" />
      </div>
      {me?.user?.demo && <p className="text-sm text-[#B45309]">This is the demo family. Use "Reset demo" in Family → Settings instead.</p>}
      <button data-testid="delete-account-btn" disabled={text !== "DELETE" || busy} onClick={go} className="ul-btn w-full" style={{ background: "#F59E0B", color: "#fff" }}>Delete my account</button>
      <button data-testid="delete-cancel-btn" onClick={() => nav(-1)} className="ul-btn ul-ghost w-full">Cancel</button>
    </div>
  );
}
